/**
* Exposed CSS variabled 
*
* @prop --select-width: The width of the select default is `174px`
* @prop --select-label-padding: The padding of the select label default is `0.5rem 0.75rem`
* @prop --select-label-font-size: The font size of the select label default is `0.875rem`
* @prop --select-label-weight: The font weight of the select label default is `500`
* @prop --select-label-border-width: The border width of the select label default is `1px`
* @prop --select-label-border-color: The border color of the select label default is `$neutral-500`
* @prop --select-label-gap: The gap between the select label default is `1rem`
* @prop --select-label-radius: The border radius of the select label default is `0.35rem`
* @prop --select-dropdown-padding: The padding of the select dropdown default is `0.35rem`
* @prop --select-dropdown-radius: The border radius of the select dropdown default is `0.35rem`
* @prop --select-dropdown-height: The height of the select dropdown, useful when the select is scrollable default is `10rem`
* @prop --select-dropdown-border-color: The border color of the select dropdown default is `$neutral-500`
* @prop --select-dropdown-border-width: The border width of the select dropdown default is `1px`
* @prop --select-label-color: The color of the select label default is `--amalitech-color-dark`
* @prop --select-font-family: The font family of the select default is `--amalitech-font-family-sans`
*/
